<template>
    <div>
        <div class="page-title">
            <h4>{{$t('placeholder.pif')}}</h4>
        </div>
        <div class="offer-add-client single-wrapper-upper">
            <div class="offer-add-option" v-if="!client_form_status">
                <div class="offer-select-type">
                    <v-select name="client_id" v-model="select_client" @change="changeClient(select_client.id)" :options="clients" :get-option-label="clientName" :placeholder="$t('placeholder.alegeClient')">  </v-select>
                    <p class="custom-error-info"> {{errors.first('client_id')}} </p>
                </div>
                <span class="connector"> {{$t('txt.connector')}} </span>
                <div class="add-client-button">
                    <button type="button" v-on:click="client_form_status = !client_form_status">
                        <i class="fas fa-user-plus"></i>
                        <span> {{$t('txt.adaugaClient')}} </span>
                    </button>
                </div>
            </div>
            <div class="offer-client-form works-client-template" v-bind:class="{ocf_active : client_form_status}">
                <h4> {{$t('txt.adaugaClient')}} </h4>
                <div class="form-group"
                     v-for="input_field in add_client_fields"
                     :key="input_field.id">
                    <input type="text" class="form-control"
                           placeholder=""
                           v-validate="input_field.validationRules"
                           :name="input_field.inputName"
                           v-model="input_field.inputValue"
                           :data-vv-as="input_field.labelName"
                           :id="input_field.inputName">
                    <label class=""> {{input_field.labelName}} </label>
                    <span class="focus-input"></span>
                    <span class="symbol-input">
                        <i v-bind:class="input_field.icon"></i>
                    </span>
                    <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                </div>
                <div class="offer-return-button">
                    <button type="button" v-on:click="client_form_status = !client_form_status">
                        <i class="fas fa-long-arrow-alt-left"></i>
                        {{$t('txt.inapoi')}}
                    </button>
                    <button type="button" @click.prevent="addClient()">
                        <i class="fas fa-check"></i>
                        {{$t('salveaza')}}
                    </button>
                </div>
            </div>
        </div>
        <form id="pifs" method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="works-template">
                        <h4> {{$t('txt.dataEstimarePif')}}: </h4>
                        <div class="form-group">
                            <date-picker :not-before="new Date()" v-model="start_date" type="datetime" value-type="format" lang="en" format="YYYY:MM:DD HH:mm:ss"></date-picker>
                            <p class="custom-error-info"> {{errors.first('start_date')}} </p>
                        </div>
                    </div>
                    <div class="works-template">
                        <h4> {{$t('txt.dataRealizata')}}: </h4>
                        <div class="form-group">
                            <date-picker :not-before="new Date()" name="done_date" v-model="done_date" value-type="format" type="datetime" lang="en" format="YYYY:MM:DD HH:mm:ss"></date-picker>
                            <p class="custom-error-info"> {{errors.first('done_date')}} </p>
                        </div>
                    </div>
                    <div class="works-template">
                        <h4> {{$t('txt.serieEchipament')}}: </h4>
                        <div class="form-group">
                            <input type="text" class="form-control" v-model="equipment_serial">
<!--                            <label> {{$t('txt.serieEchipament')}}: </label>-->
                            <span class="focus-input"></span>
                            <span class="symbol-input">
<!--                                <i class="fas fa-hashtag"></i>-->
                            </span>
                        </div>
                    </div>
                    <div class="works-template">
                        <h4> {{$t('txt.adresaMontaj')}}: </h4>
                        <div class="form-group">
                            <v-select :options="this.locations" v-model="select_location" label="name"  @change="changeLocation(select_location.id)" placeholder="Selecteaza Locatia:"></v-select>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="pif-inner-column">
                        <div class="form-group" v-for="(input_field, index) in client_fields.location" :key="`C-${index}`" :class="{ocf_active : select_location_form_status}">
                            <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 3">
                                <label :class="{select_label_class:selected_label === 3}"> {{$t('placeholder.judet')}} </label>
                                <div class="symbol-input" :class="{symbol_input_class:selected_label === 3}">
                                    <i :class="input_field.icon"></i>
                                </div>
                                <v-select v-model="selected_county_location"
                                          :options="counties"
                                          label="name"
                                          :data-vv-as="input_field.labelName"
                                          :data-vv-name="input_field.inputName"
                                          v-validate="input_field.validationRules"
                                          @change="getCitiesByCountyLocation()">
                                </v-select>
                            </div>
                            <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 4">
                                <label :class="{select_label_class:selected_label === 4}"> {{$t('placeholder.oras')}} </label>
                                <div class="symbol-input" :class="{symbol_input_class:selected_label === 4}">
                                    <i :class="input_field.icon"></i>
                                </div>
                                <v-select v-model="selected_city_location"
                                          :options="cities_location"
                                          :data-vv-as="input_field.labelName"
                                          :data-vv-name="input_field.inputName"
                                          v-validate="input_field.validationRules"
                                          label="name"></v-select>
                            </div>
                            <div v-else>
                                <input type="text"
                                       class="form-control"
                                       placeholder=""
                                       v-validate="input_field.validationRules"
                                       :name="input_field.inputName"
                                       :data-vv-as="input_field.labelName"
                                       v-model="input_field.inputValue"
                                >
                                <label class=""> {{input_field.labelName}} </label>
                                <span class="focus-input"></span>
                                <span class="symbol-input">
                                                        <i v-bind:class="input_field.icon"></i>
                                                    </span>
                                <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                            </div>
                        </div>
                        <div v-if="show_location_name">
                            <div class="form-group custom-error-group" v-for="(input_field, index) in location_name.name" :key="`D-${index}`">
                                <input type="text" class="form-control"
                                       placeholder=""
                                       v-validate="input_field.validationRules"
                                       :name="input_field.inputName"
                                       v-model="input_field.inputValue"
                                       :data-vv-as="input_field.labelName"
                                       :id="input_field.inputName">
                                <label class=""> {{input_field.labelName}} </label>
                                <span class="focus-input"></span>
                                <span class="symbol-input">
                                                <i :class="input_field.icon"></i>
                                            </span>
                                <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="works-save-buttons">
                <button @click.prevent='editPif()' :disabled="this.$store.state.loading">
                    <i class="fas fa-check"></i>
                    {{$t('placeholder.salveaza')}}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import ClientsService from '../../api-services/clients.service.js'
import PifServices from '../../api-services/pif.service.js'
import CountiesService from '../../api-services/counties.service.js'
export default {
  name: 'EditPif',
  data () {
    return {
      flagLocation: true,
      clients: [],
      client: null,
      products: [],
      client_form_status: false,
      select_client: null,
      equipment_serial: null,
      billing_number: null,
      pif: [],
      select_location: null,
      locations: [],
      done_date: null,
      start_date: null,
      city: [],
      county: [],
      selected_county_location: null,
      selected_city_location: null,
      cities_location: null,
      show_location_name: false,
      clientClone: null,
      pifClone: null,
      selected_label: null,
      select_location_form_status: false,
      counties: [],
      select_client_form_status: true,
      add_client_form_status: false,
      changeClientOrder: false,
      select_locationId: 0
    }
  },
  components: {
    DatePicker
  },
  computed: {
    add_client_fields () {
      return [
        {
          inputName: 'first_name',
          labelName: this.$t('placeholder.nume'),
          inputValue: '',
          icon: 'fas fa-signature',
          validationRules: ''
        },
        {
          inputName: 'last_name',
          labelName: this.$t('placeholder.prenume'),
          inputValue: null,
          icon: 'fas fa-signature',
          validationRules: ''
        },
        {
          inputName: 'company_name',
          labelName: this.$t('placeholder.numeCompanie'),
          inputValue: null,
          icon: 'fas fa-building',
          validationRules: ''
        },
        {
          inputName: 'phone',
          labelName: this.$t('placeholder.telefon'),
          inputValue: '',
          icon: 'fas fa-phone',
          validationRules: 'numeric'
        },
        {
          inputName: 'address',
          labelName: this.$t('placeholder.adresa'),
          inputValue: '',
          icon: 'fas fa-map-marker-alt',
          validationRules: ''
        },
        {
          inputName: 'email',
          labelName: this.$t('placeholder.email'),
          inputValue: '',
          icon: 'fas fa-envelope',
          validationRules: 'email'
        }
      ]
    },
    location_name () {
      return {
        name: [
          {
            inputName: 'location_name',
            labelName: this.$t('placeholder.denumireLocatie'),
            inputValue: '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ]
      }
    },
    client_fields () {
      return {
        location: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.select_location) ? this.select_location.address : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ]
      }
    }
  },
  watch: {
    select_location: function (newValue, oldValue) {
      if (newValue == null) {
        this.select_city = null
        this.select_county = null
        this.selected_city_location = null
        this.selected_county_location = null
        this.select_location = null
        this.$set(this.clientClone, 'address', null)
      }
    }
  },
  methods: {
    getCounties () {
      CountiesService.getAll({ per_page: -1 })
        .then((response) => {
          this.counties = response.data.data
          this.getCitiesByCounty()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCitiesByCounty () {
      let countyId = this.selected_county_location.id
      this.cities = []
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities = response.data.data.cities
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    editPif () {
      let formData = new FormData(document.getElementById('pifs'))
      if (!this.select_client) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectClient'),
          'animation-type': 'css'
        })
        return false
      }

      if (!this.selected_county_location) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selecteazaJudet'),
          'animation-type': 'css'
        })
        return false
      }
      if (!this.selected_city_location) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selecteazaOras'),
          'animation-type': 'css'
        })
        return false
      }
      if (this.equipment_serial) {
        formData.append('equipment_serial', this.equipment_serial)
      }
      if (this.select_client) {
        formData.append('user_id', this.select_client.id)
      }
      if (this.select_location.id !== 0) {
        let existingLocation = {
          county_id: this.selected_county_location.id,
          city_id: this.selected_city_location.id,
          location_id: this.select_location.id,
          start_date: this.start_date,
          done_date: this.done_date
        }
        formData.append('location', JSON.stringify(existingLocation))
      } else {
        let locationObject = {
          county_id: this.selected_county_location.id,
          city_id: this.selected_city_location.id,
          start_date: this.start_date,
          done_date: this.done_date
        }
        formData.append('location', JSON.stringify(locationObject))
      }

      PifServices.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.pifEditat'),
            'animation-type': 'css'
          })
          this.$router.push('/service/pif')
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            let errors = Object.entries(error.response.data.error)
            let msgError = ''
            for (const [key, msg] of errors) {
              console.log(key)
              msgError += '<br>' + msg
            }
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: msgError,
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    showFormCreateClient () {
      this.add_client_form_status = true
      this.select_client_form_status = false
    },
    getClients () {
      this.clients = null
      this.$store.dispatch('showLoading')
      return new Promise((resolve, reject) => {
        ClientsService.getAll({ per_page: -1 })
          .then((response) => {
            if (response.data.data.length > 0) {
              this.clients = response.data.data
            } else {
              this.clients = null
            }
            this.meta = response.data.meta
            this.$store.dispatch('hideLoading')
            resolve(this.clients)
          })
          .catch((error) => {
            let message = error.response.data.error
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: message,
              'animation-type': 'css'
            })
            this.$store.dispatch('hideLoading')
          })
      })
    },
    getPif () {
      return new Promise((resolve, reject) => {
        PifServices.get(this.$route.params.id)
          .then((response) => {
            this.pif = response.data.data
            this.locations = this.pif.client.clients_location_pif
            this.select_client = this.clients.find(client => client.id === this.pif.client.id)
            this.start_date = this.pif.start_date
            this.done_date = this.pif.done_date
            this.equipment_serial = this.pif.equipment_serial
            resolve(response)
          })
          .catch((error) => {
            let message = error.response.data.error
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: message,
              'animation-type': 'css'
            })
            reject(error)
          })
      })
    },
    addClient () {
      let clientObj = {}
      this.add_client_fields.forEach(function (element) {
        let key = [element.inputName]
        clientObj[key] = element.inputValue
      })
      ClientsService.create(clientObj)
        .then((response) => {
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.clientAdaugat'),
            'animation-type': 'css'
          })
          this.clients.push(response.data.data)
          this.select_client = this.clients.find(client => client.id === response.data.data.id)
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) return
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    changeLocation (id) {
      if (this.flagLocation) {
        this.select_location = this.pif.location
        this.flagLocation = false
      } else {
        this.select_location = this.locations.find(location => location.id === id)
      }
      if (id === 0) {
        this.show_location_name = true
        this.selected_county_location = null
        this.selected_city_location = null
      } else {
        this.show_location_name = false
        this.selected_county_location = this.select_location.county
        this.getCitiesByCountyLocation()
        let vm = this
        this.client_fields.location.forEach(function (element) {
          if (element.inputName === 'address') {
            element.inputValue = vm.select_location.address
          }
        })
      }
    },
    changeClient (id) {
      this.select_client = this.clients.find(client => client.id === id)
      this.clientClone = _.cloneDeep(this.select_client)
      this.locations = this.select_client.locations
      this.select_location = this.locations[0]
      let addLocationExists = this.locations.find(location => location.name === 'Adauga locatie')
      if (addLocationExists === undefined) {
        let addNew = {
          id: 0,
          name: 'Adauga locatie'
        }
        this.locations.push(addNew)
      }
      return false
    },
    getCitiesByCountyLocation () {
      let countyId = ''
      if (this.selected_county_location) {
        countyId = this.selected_county_location.id
      }
      this.cities = []
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities_location = response.data.data.cities
            if (this.select_location.city) {
              this.selected_city_location = this.cities_location.find(city => city.id === this.select_location.city.id)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
  },
  async created () {
    this.$store.dispatch('hideLoading')
    await this.getClients()
    this.getCounties()
    await this.getPif()
  }
}
</script>
